import { render, staticRenderFns } from "./B2SConfiguration.vue?vue&type=template&id=28dcb7c1"
import script from "./B2SConfiguration.vue?vue&type=script&lang=js"
export * from "./B2SConfiguration.vue?vue&type=script&lang=js"
import style0 from "./B2SConfiguration.vue?vue&type=style&index=0&id=28dcb7c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports